/**
 * VEC-3315 — catálogo de tipos de movimiento del lado del frontend.
 *
 * Espeja las constantes del modelo `ItemStockMovimiento`. HOY EXISTE UNO SOLO, `INGRESO`, que es lo
 * único que escribe VEC-3314; los otros cinco que enumera la card (RESERVA, DESPACHO, CONSUMO,
 * DEVOLUCIÓN, AJUSTE) los agrega cada card de la épica que los implemente. Sumar un tipo acá lo hace
 * aparecer a la vez en el filtro y en la columna, que es la razón de que la lista y la traducción
 * vivan juntas y en un solo archivo.
 *
 * `etiquetaDeTipo` cae al valor crudo para un tipo que el backend devuelva y este catálogo todavía
 * no conozca: mostrar "DESPACHO" es mejor que mostrar un guion o una fila en blanco.
 */

export const TIPO_INGRESO = 'INGRESO';

export const TIPOS_DE_MOVIMIENTO = [TIPO_INGRESO];

export const etiquetaDeTipo = (intl, tipo) => {
	// Los ids van literales y no por variable: `formatjs extract` no resuelve un id que llega por
	// parámetro, y la clave quedaría fuera del catálogo de traducciones.
	if (tipo === TIPO_INGRESO) {
		return intl.formatMessage({ id: 'inventarioMovimientos.tipo_ingreso', defaultMessage: 'Ingreso' });
	}

	return tipo || '-';
};
